'use client';
import { createContext } from 'react';
export const SurfaceContext = createContext({
    portalTargetElement: null,
    elevation: undefined,
});
SurfaceContext.displayName = 'SurfaceContext';
//# sourceMappingURL=SurfaceContext.js.map